import api from '../../services/api';
import { Creators } from '../ducks/rec_customer_event';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getRecCustomerEvent({ id }) {
  try {

    yield put(Creators.recCustomerEventRequest());
    const response = yield call(api.post, 'rec-customer-event', { id });

    yield put(Creators.recCustomerEventTopRecommendations(response.data.items));
    yield put(Creators.recCustomerEventSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, id);
    yield put(Creators.recCustomerEventError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao listar recomendação de eventos por clientes'
    }));
  }
}